import { LandingPage } from '@bo-views/LandingPage';
import { Outlet } from 'react-router-dom';
import { useGetAdminCurrentQuery } from '@bo-services/authenticationApi';

export const AuthenticatedRoutes = () => {
  const { isSuccess } = useGetAdminCurrentQuery();

  if (!isSuccess) {
    return null;
  }

  return (
    <LandingPage>
      <Outlet />
    </LandingPage>
  );
};
